import React, { forwardRef, useEffect, useState } from "react";
import { showConfirm } from "../../utility/showconfirm";

const Actionstate = forwardRef(({ meetingInfo, userID, onActionClick ,setShowBottom},ref) => {

  const [action, setAction] = useState(null);
  const setupActions = () => {

    if (!meetingInfo) return;

    const isHost = meetingInfo.hostempid == userID;
    const stage = meetingInfo.stage;
    const joined = meetingInfo.joined;

    if (isHost) {
      if (stage == "0") {

        setAction({
          text: "Start Meeting",
          color: "#4caf50",
          onClick: () => {

            let msg = "Are you sure you want to start this meeting?";

            const startTime = new Date(meetingInfo.scheduledtime.date);

            if (startTime && startTime.getTime() - Date.now() > 60000) {
              msg = "Are you sure you want to start this meeting before scheduled time?";
            }

            showConfirm({
                content: msg,
                 hideCancel: false,
                 okText: "Yes",
                 cancelText: "No"
             }).then(result => {
              if (result == true) {
                const query = `HRApp_Droid_Proc_User_Meeting_Start @UserID='{0}',@MeetingID='{1}'`;
                const queryArr = [`${userID}`, `${meetingInfo.meetingid}`];
                onActionClick(query, queryArr, "REQUEST_START_MEETING");
              }
            })

          }
        });

      }

      
      else if (stage == "1") {
console.log("dfagshj")
        setAction({
          text: "End Meeting",
          color: "#ff4d4f",
          onClick: () => {

            showConfirm({
                content: "Are you sure you want to end this meeting?",
                    hideCancel: false,
                    okText: "Yes",
                    cancelText: "No"
             }).then(result => {
               if (result == true) {

                    const query = `HRApp_Droid_Proc_User_Meeting_End @UserID='{0}',@MeetingID='{1}'`;
                    const queryArr = [`${userID}`, `${meetingInfo.meetingid}`];
                    onActionClick(query,queryArr, "REQUEST_END_MEETING");
                }
            })
            

          }
        });

      }

      else if (stage == "2" || stage == "-1") {

        setAction({
          text: "Reschedule Meeting",
          color: "#ffc107",
          onClick: () => {
             onActionClick("","", "REQUEST_RESCHEDULE_MEETING");
            // navigate("/addmeeting", { state: { DefData: meetingInfo } });
          }
        });

      }

      else {
        setAction(null);
      }

    }

 
    else if (stage == "1") {

      if (joined == "0") {
        setAction({
          text: "Join Meeting",
          color: "#4caf50",
          onClick: () => {
            onActionClick("","", "REQUEST_JOIN_MEETING");
          }
        });

      }

      else {

        setAction({
          text: "Leave Meeting",
          color: "#ff4d4f",
          onClick: () => {
 showConfirm({
                content: "Are you sure you want to leave this meeting?",
                    hideCancel: false,
                    okText: "Yes",
                    cancelText: "No"
             }).then(result => {
               if (result == true) {
                    const query = `HRApp_Droid_Proc_User_Meeting_Leave @UserID='{0}',@MeetingID='{1}'`;
                    const queryArr = [`${userID}`, `${meetingInfo.meetingid}`];
              onActionClick(query,queryArr, "REQUEST_LEAVE_MEETING");
                }
 })
          }
        });

      }

    }

    else {
      setAction(null);
      setShowBottom(true)
    }

  };

  useEffect(() => {
    setupActions();
  }, [meetingInfo]);

  console.log(meetingInfo, "meetingInfo");

  return (
    <>
    
      {action && (
        <div ref={ref} style={{ backgroundColor:"white", marginTop: "10px" , position:"sticky" , width:"100%", bottom:"0px" ,zIndex:1, padding:"12px" , borderTop:"1px solid #ddd" }}>
          <button
            style={{
              borderRadius:"10px",
                width: "100%",
              background: action.color,
              color: "#fff",
              padding: "15px 20px",
              border: "none",
              fontWeight:"700",
              cursor: "pointer"
            }}
            onClick={action.onClick}
          >
            {action.text}
          </button>
        </div>
      )}
    </>
  );
});

export default Actionstate;